<template>
    <custom-node
        variant="full"
        :handles="[{ type: 'target', position: Position.Top }]"
        v-bind="$attrs"
    >
        <template #icon>
            <svg-icon
                class="node-icon"
                :icon="IconFlagCheckered"
                color="#bdd49d"
                is-custom-icon
            />
        </template>

        <template #content>
            <h2>Opvolging voltooid</h2>
        </template>
    </custom-node>

    <teleport to=".vue-flow__viewport">
        <div
            ref="confetti"
            class="confetti"
            :style="{ opacity: confettiOpacity }"
        />
    </teleport>
</template>

<script setup lang="ts">
    import { SvgIcon } from '@keyvue/one-ui';
    import { ref } from 'vue';
    import { Position, useVueFlow } from '@vue-flow/core';
    import type { Node } from '@keyvue/one-api-client';
    import CustomNode from '@/flow/flow/components/graph/custom-types/CustomNode.vue';

    import IconFlagCheckered from '@keyvue/one-awesome-icons/icons/solid/flag-checkered.svg?component';

    interface Props {
        data: Node
    }

    defineProps<Props>();

    const { onMove, nodes } = useVueFlow();
    const confetti = ref<HTMLDivElement | null>(null);
    const confettiOpacity = ref(0);

    onMove((event) => {
        if (!confetti.value || !confetti.value.parentElement) {
            return;
        }

        const endNodes = nodes.value.filter((node) => node.type === 'node_end');

        const firstEndNode = endNodes[0];
        if (!firstEndNode) {
            return;
        }

        const nodeTop = firstEndNode.position.y;
        const nodeBottom = nodeTop + firstEndNode.dimensions.height;
        const flowViewportTop = -event.flowTransform.y / event.flowTransform.zoom;
        const flowViewportBottom = flowViewportTop + confetti.value.parentElement.clientHeight / event.flowTransform.zoom;

        if (flowViewportBottom < nodeTop) {
            confettiOpacity.value = 0;
        } else if (flowViewportBottom > nodeBottom) {
            confettiOpacity.value = 1;
        } else {
            confettiOpacity.value = (flowViewportBottom - nodeTop) / (nodeBottom - nodeTop);
        }
    });
</script>

<style scoped lang="scss">
.custom-node {
    background-color: #f1f5ea;
    color: #bdd49d;
    border: solid 2px #bdd49d;
    border-radius: size(md);

    &[selected="false"] {
        &:hover {
            background-color: #ED6E2D;
            color: white;
            border-color: #ED6E2D;

            :deep(.node-icon) {
                fill: #ED6E2D;
            }
        }
    }

    &[selected="true"] {
        border-color: color(red-500);
    }
}

.confetti {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 20vh;
    background-image: url('@/flow/flow/assets/confetti.png');
    background-repeat: repeat-x;
    background-position: bottom;
    background-size: 100%;
}
</style>
